import styles from "./TagsCell.module.scss";
import { Tag } from "@/frontend/shared/ui/Tag";

export function TagsCell({ tags }: { tags: { tag: { id: number; name: string } }[] }) {
  return (
    <div className={styles.container}>
      {tags.map((t) => (
        <div className={styles.tag} key={t.tag.id}>
          <Tag children={t.tag.name} size="small" key={t.tag.id} />
        </div>
      ))}
    </div>
  );
}
